import React from 'react';
import type { Clase, Recurso } from '../../types';
import { Tarjeta } from '../ui/Tarjeta';
import { Aviso } from '../ui/Aviso';
import { CampoArea } from '../ui/Campo';
import { Insignia } from '../ui/Etiquetas';
import { PanelTiempo } from './PanelTiempo';
import { CHECKS_LOGISTICA } from '../../data/constantes';
import { calcularAdvertencias } from '../../utils/reglas';
import { formatearFecha } from '../../utils/clase';
interface Props {
  clase: Clase;
  actualizar: (parcial: Partial<Clase>) => void;
  recursos: Recurso[];
}
export function Paso4Revision({
  clase,
  actualizar,
  recursos
}: Props) {
  const advertencias = calcularAdvertencias(clase, recursos);
  const objetivo = clase.objetivo === 'Personalizado' ? clase.objetivoPersonalizado || 'Personalizado' : clase.objetivo;
  return <div className="space-y-4" data-id="element-184" data-mp="1d7aggiblciy1">
      <PanelTiempo clase={clase} data-id="element-185" data-mp="1d82avptgcamq" />

      <Tarjeta data-id="element-186" data-mp="1d93r08pbrnbb">
        <h2 className="text-lg font-bold text-tinta-titulo" data-id="element-187" data-mp="1i5kc0u189lk6">Datos del grupo</h2>
        <dl className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-188" data-mp="1i7oqg5wr62yp">
          <Dato termino="Título" valor={clase.titulo || 'Sin título'} data-id="element-189" data-mp="22vsr554yoeu9" />
          <Dato termino="Fecha" valor={formatearFecha(clase.fecha)} data-id="element-190" data-mp="1y27q1482n4qu" />
          <Dato termino="Grupo o espacio" valor={clase.grupo || '—'} data-id="element-191" data-mp="1t3daqc9bbybh" />
          <Dato termino="Población" valor={clase.poblacion} data-id="element-192" data-mp="1t1jy8gc0qjvk" />
          <Dato termino="Nivel" valor={clase.nivel} data-id="element-193" data-mp="1o64rs9gcbq96" />
          <Dato termino="Autonomía" valor={clase.autonomia} data-id="element-194" data-mp="2lsbrb4xseseo" />
          <Dato termino="Participantes" valor={String(clase.participantes)} data-id="element-195" data-mp="2lrskaj9odoff" />
          <Dato termino="Telas o puntos" valor={String(clase.puntos)} data-id="element-196" data-mp="2gusf0akngppd" />
          <Dato termino="Duración" valor={`${clase.duracion} min`} data-id="element-197" data-mp="2btuvnunwlpma" />
          <Dato termino="Tipo" valor={clase.tipo} data-id="element-198" data-mp="2bw8pk06ukvs9" />
          <Dato termino="Altura" valor={clase.altura} data-id="element-199" data-mp="27s1020skfbsz" />
          <Dato termino="Objetivo" valor={objetivo} data-id="element-200" data-mp="10f8y16sbqkza" />
        </dl>
        {clase.consideraciones && <p className="mt-3 rounded-xl border border-linea bg-lienzo p-3 text-sm text-tinta" data-id="element-201" data-mp="wdvsyyx22ltf">
            <span className="font-semibold" data-id="element-202" data-mp="xv2liapn9m74">Consideraciones: </span>
            {clase.consideraciones}
          </p>}
      </Tarjeta>

      <Tarjeta data-id="element-203" data-mp="12skz4eelwplg">
        <h2 className="text-lg font-bold text-tinta-titulo" data-id="element-204" data-mp="12t4fvrsit7xw">Logística</h2>
        <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-3" data-id="element-205" data-mp="nvlki6lc7whh">
          <Dato termino="Estrategia" valor={clase.logistica.estrategia} data-id="element-206" data-mp="svgbsb90yo32" />
          <Dato termino="Profes o asistentes" valor={String(clase.logistica.profes)} data-id="element-207" data-mp="sxj8fe4onfgr" />
          <Dato termino="Nota" valor={clase.logistica.nota || '—'} data-id="element-208" data-mp="f28h2apndch5" />
        </div>
        <ul className="mt-3 space-y-1 text-sm" data-id="element-209" data-mp="jwl0wlv1cptf">
          {CHECKS_LOGISTICA.map(c => <li key={c.id} className="flex items-start gap-2" data-id="element-210" data-mp="57ggqz4okbio">
              <span className={`mt-0.5 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded border text-[10px] font-bold ${clase.logistica.checks[c.id] ? 'border-verde bg-verde/10 text-verde' : 'border-linea text-tinta-tenue'}`} aria-hidden="true" data-id="element-211" data-mp="a4p2tasy8zp7">
                {clase.logistica.checks[c.id] ? '✓' : ''}
              </span>
              <span className={clase.logistica.checks[c.id] ? 'text-tinta' : 'text-tinta-tenue'} data-id="element-212" data-mp="38r4mrdupzumi">
                {c.texto}
                {!clase.logistica.checks[c.id] && ' (sin confirmar)'}
              </span>
            </li>)}
        </ul>
      </Tarjeta>

      <Tarjeta data-id="element-213" data-mp="gbcril2yv0i">
        <h2 className="text-lg font-bold text-tinta-titulo" data-id="element-214" data-mp="frz4e2gqssa">Bloques y ejercicios</h2>
        <ol className="mt-3 space-y-3" data-id="element-215" data-mp="3rne6agoe5ddw">
          {clase.bloques.map(b => <li key={b.uid} className="rounded-xl border border-linea p-3" data-id="element-216" data-mp="98v7w925yhgl">
              <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-217" data-mp="57t5jjcy9pae">
                <h3 className="text-sm font-bold text-tinta-titulo" data-id="element-218" data-mp="j83z4u5n9hz9">{b.nombre}</h3>
                <Insignia tono="vino" data-id="element-219" data-mp="j5rhki3st9mq">{b.minutos} min</Insignia>
              </div>
              {b.objetivo && <p className="mt-1 text-sm text-tinta-sec" data-id="element-220" data-mp="e6ws4xbbsmtn">{b.objetivo}</p>}
              {b.notas && <p className="mt-1 text-sm text-tinta-tenue" data-id="element-221" data-mp="yavnnuxon3jp">{b.notas}</p>}
              {b.ejercicios.length === 0 ? <p className="mt-2 text-sm text-tinta-tenue" data-id="element-222" data-mp="12act4od400ov">Sin ejercicios asignados.</p> : <ul className="mt-2 space-y-2" data-id="element-223" data-mp="1c2irqgxv9gd1">
                  {b.ejercicios.map(e => <li key={e.uid} className="rounded-lg bg-lienzo p-2 text-sm" data-id="element-224" data-mp="fc9lecqfj6e7">
                      <p className="font-semibold text-tinta-titulo" data-id="element-225" data-mp="fecgvcacprqb">{e.nombre || 'Sin nombre'}</p>
                      <p className="text-tinta-sec" data-id="element-226" data-mp="jfxuizupma1k">
                        {e.minutos} min · {e.variacion} · {e.modalidad} · Lado: {e.lado}
                        {e.seriesRepes ? ` · ${e.seriesRepes}` : ''}
                      </p>
                      {e.notas && <p className="text-tinta-tenue" data-id="element-227" data-mp="1zswfvwdbyv2c">{e.notas}</p>}
                    </li>)}
                </ul>}
            </li>)}
        </ol>
      </Tarjeta>

      <Tarjeta data-id="element-228" data-mp="3p870tnon71pc">
        <h2 className="text-lg font-bold text-tinta-titulo" data-id="element-229" data-mp="3p8p6tc13wuag">Advertencias para revisar</h2>
        {advertencias.length === 0 ? <Aviso tipo="ok" className="mt-3" titulo="Sin advertencias pendientes" data-id="element-230" data-mp="3kchzbet2baqe">
            La revisión automática no encontró puntos para señalar.
          </Aviso> : <div className="mt-3 space-y-2" data-id="element-231" data-mp="3ak2jan1bsw85">
            {advertencias.map(a => <Aviso key={a.id} tipo={a.tipo} titulo={a.titulo} data-id="element-232" data-mp="36kbw0tb0cy8d">
                {a.detalle}
              </Aviso>)}
          </div>}
      </Tarjeta>

      <Tarjeta data-id="element-233" data-mp="2wjrppc8mt3ja">
        <CampoArea etiqueta="Recordatorio para esta clase" value={clase.recordatorio} onChange={e => actualizar({
        recordatorio: e.target.value
      })} ayuda="Se imprime junto con la planificación." data-id="element-234" data-mp="2wlcjv0r1akgm" />
      </Tarjeta>
    </div>;
}
function Dato({
  termino,
  valor
}: {
  termino: string;
  valor: string;
}) {
  return <div className="rounded-xl border border-linea bg-lienzo p-3" data-id="element-235" data-mp="2kalktflyg7lw">
      <dt className="text-xs font-bold uppercase tracking-wide text-tinta-tenue" data-id="element-236" data-mp="2k88tibub4kw6">{termino}</dt>
      <dd className="mt-1 text-sm font-semibold text-tinta-titulo" data-id="element-237" data-mp="2p2d2f0n4v2zw">{valor}</dd>
    </div>;
}